import { useState } from "react";
import { faqs } from "../../../mocks/services";

export default function FAQSection() {
  const [openId, setOpenId] = useState<number | null>(1);

  return (
    <section className="bg-[#F8F7F4] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-5 gap-12 items-start">
          {/* Left */}
          <div className="lg:col-span-2">
            <p className="text-[#E8500A] font-bold text-xs tracking-widest uppercase mb-3">FAQ</p>
            <h2 className="text-4xl lg:text-5xl font-black text-gray-900 mb-5 leading-tight" style={{ fontFamily: "'Barlow', sans-serif" }}>
              Common Questions Answered
            </h2>
            <p className="text-gray-500 leading-relaxed mb-8">
              Straight answers to the questions DFW homeowners and businesses ask us most. Have something specific? Call us anytime.
            </p>

            {/* Contact card */}
            <div className="bg-white rounded-2xl p-6 border border-gray-100 space-y-4">
              <div className="flex items-center gap-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-orange-50 flex-shrink-0">
                  <i className="ri-phone-line text-[#E8500A] text-lg" />
                </div>
                <div>
                  <p className="font-bold text-gray-900 text-sm">Call Anytime — 24/7</p>
                  <a href="tel:8178324968" className="text-[#E8500A] font-black text-lg hover:text-[#d14508] transition-colors" style={{ fontFamily: "'Barlow', sans-serif" }}>
                    (817) 832-4968
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-orange-50 flex-shrink-0">
                  <i className="ri-phone-line text-[#E8500A] text-lg" />
                </div>
                <div>
                  <p className="font-bold text-gray-900 text-sm">Dallas Direct Line</p>
                  <a href="tel:9722625113" className="text-[#E8500A] font-black text-lg hover:text-[#d14508] transition-colors" style={{ fontFamily: "'Barlow', sans-serif" }}>
                    (972) 262-5113
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-orange-50 flex-shrink-0">
                  <i className="ri-mail-line text-[#E8500A] text-lg" />
                </div>
                <div>
                  <p className="font-bold text-gray-900 text-sm">Email Us</p>
                  <a href="mailto:jph832@yahoo.com" className="text-gray-600 hover:text-[#E8500A] text-sm transition-colors">
                    jph832@yahoo.com
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Right accordion */}
          <div className="lg:col-span-3">
            <dl className="space-y-3">
              {faqs.map((faq) => (
                <div
                  key={faq.id}
                  className={`rounded-xl border transition-all duration-200 overflow-hidden ${
                    openId === faq.id ? "border-[#E8500A]/30 bg-orange-50/60" : "border-gray-200 bg-white hover:border-orange-200"
                  }`}
                >
                  <dt>
                    <button
                      className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
                      onClick={() => setOpenId(openId === faq.id ? null : faq.id)}
                      aria-expanded={openId === faq.id}
                    >
                      <span className={`font-bold text-sm pr-4 leading-snug ${openId === faq.id ? "text-[#E8500A]" : "text-gray-900"}`}>
                        {faq.question}
                      </span>
                      <span className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-colors ${openId === faq.id ? "bg-[#E8500A] text-white" : "bg-gray-100 text-gray-500"}`}>
                        <i className={`text-sm ${openId === faq.id ? "ri-subtract-line" : "ri-add-line"}`} />
                      </span>
                    </button>
                  </dt>
                  {openId === faq.id && (
                    <dd className="px-6 pb-5">
                      <p className="text-gray-600 text-sm leading-relaxed">{faq.answer}</p>
                    </dd>
                  )}
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}
